import { mutatorAction } from 'satcheljs';
import CLPUserLabelStore from '../store/schema/CLPUserLabelStore';
import { getStore } from '../store/store';

export default mutatorAction('initializeCLPStore', (labelInfoFromResp: CLPUserLabelStore) => {
    const clpStore = getStore();
    clpStore.userLabels = labelInfoFromResp.userLabels;
    clpStore.learnMoreUrl = labelInfoFromResp.learnMoreUrl;
});
